import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {Construct} from 'classes/construct';
import {Dialog} from 'classes/dialog';
import {Language} from 'classes/language';
import {ConstructsDetailsService} from './services/constructs-details.service';

@Component({
  selector: 'constructs-details',
  templateUrl: './constructs-details.component.html',
  styleUrls: ['./constructs-details.component.css'],
})
export class ConstructsDetailsComponent implements OnInit {

  public title: string = 'Neues Konstrukt';
  public construct: Construct = new Construct();
  public languages: Array<Language> = Language.defaultLanguages;
  public language: string = this.languages[0].code;

  constructor(private detailsService: ConstructsDetailsService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {

    this.construct.addEmptyQuestion();
    this.enrichMinMaxLabel();
  }

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe((parameters) => {
      if (parameters['constructId']) {
        if (parameters.clone === 'true') {
          this.detailsService.getConstructCloneById(parameters['constructId'])
            .subscribe((construct) => {
              this.construct = construct;
              this.enrichMinMaxLabel();
            });
        } else {
          this.title = 'Konstrukt bearbeiten';
          this.detailsService.getConstructById(parameters['constructId'])
            .subscribe((construct) => {
              this.construct = construct;
              this.enrichMinMaxLabel();
            });
        }
      }
    });
  }

  public setLanguage(language: Language): void { // tslint:disable-line
    this.language = language.code;
  }

  private saveConstruct(): void { // tslint:disable-line
    this.reduceMinMaxLabel();
    this.detailsService.saveConstruct(this.construct)
      .subscribe((response) => {
        this.router.navigate(['constructs']);
      });
  }

  private updateConstruct(): void { // tslint:disable-line
    this.reduceMinMaxLabel();
    this.detailsService.updateConstruct(this.construct)
      .subscribe((response) => {
        this.router.navigate(['constructs']);
      });
  }

  public get isUsedByActiveDialog(): boolean {
    return this.construct.dialogs.some((dialog) => {
      return dialog.active;
    });
  }

  private get activeDialogs(): Array<Dialog> {
    return this.construct.dialogs.filter((dialog) => {
      return dialog.active;
    });
  }

  private openDialog(dialogId: number): void {
    this.router.navigate(['dialogs', 'details', {dialogId: dialogId}]);
  }

  private enrichMinMaxLabel() {
    for (let i = 0; i < this.construct.questions.length; i++) {
      if (this.construct.questions[i].minLabel === undefined) {
        this.construct.questions[i].minLabel = {de: '', en: ''};
      }
      if (this.construct.questions[i].maxLabel === undefined) {
        this.construct.questions[i].maxLabel = {de: '', en: ''};
      }
    }
  }

  private reduceMinMaxLabel() {
    for (let i = 0; i < this.construct.questions.length; i++) {
      if (this.construct.questions[i].answerType != 1 && this.construct.questions[i].answerType != 2) {
        delete this.construct.questions[i].minLabel;
        delete this.construct.questions[i].maxLabel;
      }
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-details/constructs-details.component.ts